import { useState } from 'react'
import { singleToHex, hexToSingle } from '../utils/ieee754'

function FloatConverter() {
  const [decimalValue, setDecimalValue] = useState('')
  const [hexValue, setHexValue] = useState('')

  const handleDecimalChange = (e) => {
    const value = e.target.value
    setDecimalValue(value)

    if (value === '') {
      setHexValue('')
      return
    }

    try {
      const hex = singleToHex(value)
      setHexValue(hex)
    } catch (error) {
      setHexValue('')
    }
  }

  const handleHexChange = (e) => {
    const value = e.target.value
    setHexValue(value)

    if (value === '') {
      setDecimalValue('')
      return
    }

    try {
      const decimal = hexToSingle(value)
      setDecimalValue(decimal.toString())
    } catch (error) {
      setDecimalValue('')
    }
  }

  return (
    <div className="converter-section">
      <div className="section-title">IEEE 754浮点数十六进制相互转换</div>
      <div className="section-description">(32位,四字节,单精度)</div>
      
      <div className="input-group">
        <span className="input-label">10进制</span>
        <input
          type="text"
          value={decimalValue}
          onChange={handleDecimalChange}
          placeholder="输入10进制数"
          className="converter-input"
        />
      </div>

      <div className="input-group">
        <span className="input-label">16进制</span>
        <input
          type="text"
          value={hexValue}
          onChange={handleHexChange}
          placeholder="输入16进制数"
          className="converter-input"
        />
      </div>
    </div>
  )
}

export default FloatConverter
